// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.h5[data-v-5211074e] {\n  font-size: 12pt !important;\n}\n", ""]);
// Exports
module.exports = exports;
